import { lazy } from 'react';
export var SupportPageAsync = lazy(function () { return import('./SupportPage'); });
